import { createContext, useContext } from 'react';

type MyBidsPictureInPicture = {
  /** False on browsers without the Document Picture-in-Picture API. */
  supported: boolean;
  open: boolean;
  requestOpen: () => void;
};

const MyBidsPictureInPictureContext = createContext<MyBidsPictureInPicture>({
  supported: false,
  open: false,
  requestOpen: () => {},
});

export const useMyBidsPictureInPictureContext = () =>
  useContext(MyBidsPictureInPictureContext);

export const MyBidsPictureInPictureProvider =
  MyBidsPictureInPictureContext.Provider;
